export type ExtractDateComponentsResult = {
  year: string;
  month: string | null;
  week: string | null;
  day: string | null;
  hour: string | null;
};

export const extractDateComponents = (dateStr: string): ExtractDateComponentsResult | null => {
  const patterns = [
    {
      regex: /^(\d{4})-W(\d{2})$/, // Year-Week (ISO, e.g. 2024-W05)
      extract: (matches: RegExpExecArray) => ({
        year: matches[1],
        week: matches[2],
        month: null,
        day: null,
        hour: null,
      }),
    },
    {
      regex: /^(\d{4})-(\d{2})-(\d{2})T(\d{2})$/, // Year-Month-Day-Hour
      extract: (matches: RegExpExecArray) => ({
        year: matches[1],
        month: matches[2],
        week: null,
        day: matches[3],
        hour: matches[4],
      }),
    },
    {
      regex: /^(\d{4})-(\d{2})-(\d{2})$/, // Year-Month-Day
      extract: (matches: RegExpExecArray) => ({
        year: matches[1],
        month: matches[2],
        week: null,
        day: matches[3],
        hour: null,
      }),
    },
  ];

  for (const pattern of patterns) {
    const match = pattern.regex.exec(dateStr);
    if (match) {
      return pattern.extract(match);
    }
  }

  // If no format matches, handle it accordingly
  return null;
};
